import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { industries } from '../data/industries';
import type { IndustryData } from '../data/industries';

interface IndustrySelectorProps {
  onSelect: (industry: { primary: string; sub?: string }) => void;
  selectedIndustry: string | null;
}

export function IndustrySelector({ onSelect, selectedIndustry }: IndustrySelectorProps) {
  const [selectedSubIndustry, setSelectedSubIndustry] = useState<string | null>(null);
  const [showSubIndustries, setShowSubIndustries] = useState(false);
  const [currentIndustry, setCurrentIndustry] = useState<IndustryData | null>(null);

  const handleIndustryClick = (industry: IndustryData) => {
    setCurrentIndustry(industry);
    setShowSubIndustries(true);
    onSelect({ primary: industry.id });
  };

  const handleSubIndustryClick = (subIndustry: string) => {
    setSelectedSubIndustry(subIndustry);
    if (currentIndustry) {
      onSelect({ primary: currentIndustry.id, sub: subIndustry });
    }
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {industries.map((industry) => (
          <motion.div 
            key={industry.id}
            className={`p-6 border-2 border-dashed rounded-xl cursor-pointer transition-all ${
              selectedIndustry === industry.id 
                ? 'border-blue-500 bg-blue-500/10' 
                : 'border-gray-700 hover:border-blue-500/50'
            }`}
            onClick={() => handleIndustryClick(industry)}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <div className="text-3xl mb-3">{industry.icon}</div>
            <h3 className="font-medium">{industry.name}</h3>
          </motion.div>
        ))}
      </div>

      {showSubIndustries && currentIndustry && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-6"
        >
          <h4 className="text-lg mb-4">选择具体领域</h4>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-3">
            {currentIndustry.subIndustries.map((sub) => (
              <motion.button
                key={sub}
                className={`p-3 rounded-lg text-sm transition-all ${
                  selectedSubIndustry === sub
                    ? 'bg-blue-500 text-white'
                    : 'bg-white/5 hover:bg-white/10'
                }`}
                onClick={() => handleSubIndustryClick(sub)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {sub}
              </motion.button>
            ))}
          </div>
        </motion.div>
      )}
    </div>
  );
}